export default "__VITE_ASSET__9a040f23__"